import {useState, createContext} from 'react'
import './App.css'
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import Main from './components/Main'

export const FocusContext = createContext()

const App = () => {
  const [focus, setFocus] = useState(false);
  

  return (

    <FocusContext.Provider value={[focus, setFocus]}>

    <div >
      <Navbar />
      <div className="container ">

        {/* <Sidebar /> */}
        <Main/>
      </div>

    </div>
    </FocusContext.Provider>
  )
}

export default App